module.exports = __webpack_public_path__ + "static/flumph-718da15d1ad9e0f8a016c4261ca32e97.jpeg";